import { render } from "./EmployeeBanking.vue?vue&type=template&id=0418fbfa"
import script from "./EmployeeBanking.vue?vue&type=script&lang=js"
export * from "./EmployeeBanking.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__